import { render, staticRenderFns } from "./CompanionMileage.vue?vue&type=template&id=6cfe845b&"
import script from "./CompanionMileage.vue?vue&type=script&lang=js&"
export * from "./CompanionMileage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports